import dotenv from "dotenv";
dotenv.config();

const config = {
    REACT_APP_SERVER: process.env.REACT_APP_SERVER,
}

export default config;